import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CommonService } from '@fitness-force/api';
import { OccurenceType } from '@fitness-force/enum';
import { ErrorMsgComponent } from '@fitness-force/errors';
import type { PlanDeposit } from '@fitness-force/models';
import { DepositTranslatePipe } from '@fitness-force/pipes/common-pipes';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import {
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { RippleModule } from 'primeng/ripple';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'plan-deposit-modal',
  templateUrl: './plan-deposit-modal.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    RippleModule,
    ErrorMsgComponent,
    DynamicDialogModule,
    SelectModule,
    ToggleSwitchModule,
    TranslateModule,
    DepositTranslatePipe,
    NgClass,
  ],
})
export class PlanDepositModalComponent implements OnInit {
  private commonService = inject(CommonService);
  private ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private fb = inject(UntypedFormBuilder);
  private cd = inject(ChangeDetectorRef);

  addDepositsModal: boolean = false;
  depositsType1: boolean = false;
  depositsType2: boolean = false;
  depositsType3: boolean = false;

  selectedDeposit: any;
  occurenctType = Object.entries(OccurenceType)
    .filter((key) => typeof key[1] != 'number')
    .map(([key, value]) => ({ key, value }));

  occurences: {
    key: string;
    value: number;
    selected: boolean;
    occurenceType: string;
  }[] = [];
  selectedOccurences: PlanDeposit[] = [];

  depositOccurenceForm: UntypedFormGroup;
  activeDepositOccurence: PlanDeposit = {} as PlanDeposit;
  planType: any;
  planId: number = 0;
  contractTerm: number = 0;
  activeEditIndex!: number;

  constructor() {
    this.occurenctType = this.occurenctType.filter((o) => o.value != 'None');

    if (this.config.data?.deposit) {
      this.activeDepositOccurence = this.config.data?.deposit;
      this.activeEditIndex = this.config.data?.index;
    }
    if (this.config.data?.planType) {
      this.planType = this.config.data?.planType;
    }
    if (this.config.data?.planId) {
      this.planId = this.config.data?.planId;
    }
    if (this.config.data?.contractTerms) {
      this.contractTerm = this.config.data?.contractTerms;
    }
    if (this.config.data?.contractTerms) {
      this.selectedOccurences = this.config.data?.selectedOccurences;
    }
  }

  ngOnInit() {
    this.buildForm();
    this.SelectedOccurenceTypeFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (
          value.value == OccurenceType.ApplyManually ||
          value.value.toString() == OccurenceType[OccurenceType.ApplyManually]
        ) {
          this.SelectedOccurenceFormControl.clearValidators();
          this.SelectedOccurenceFormControl.disable();
          this.SelectedOccurenceFormControl.setValue(null);
          this.depositOccurenceForm.controls.add_occurence.addValidators(
            Validators.required,
          );
          this.depositOccurenceForm.controls.add_occurence.setValue(false);
        } else {
          this.SelectedOccurenceFormControl.addValidators(Validators.required);
          this.SelectedOccurenceFormControl.enable();
          this.SelectedOccurenceFormControl.setValue(null);
          this.depositOccurenceForm.controls.add_occurence.clearValidators();
          this.depositOccurenceForm.controls.add_occurence.setValue(false);
        }
        this.occurences = this.commonService.generateDepositOccurence(
          this.SelectedOccurenceTypeFormControl.value.value,
          this.contractTerm,
        );
        this.occurences.forEach((o) => {
          if (
            this.selectedOccurences.find(
              (s) =>
                s.occurence_type == o.occurenceType && o.value == s.occurence,
            )
          ) {
            o.selected = true;
          }
          //else o.selected=false;
        });
      });
  }

  buildForm() {
    this.depositOccurenceForm = this.fb.group({
      occurence_type: [
        this.activeDepositOccurence &&
        this.activeDepositOccurence.occurence_type
          ? this.occurenctType.find(
              (o) => o.value == this.activeDepositOccurence.occurence_type,
            )
          : this.occurenctType[0],
        Validators.required,
      ],
      occurence: ['', Validators.required],
      add_occurence: [false],
    });
    this.occurences = this.commonService.generateDepositOccurence(
      this.SelectedOccurenceTypeFormControl.value.value,
      this.contractTerm,
    );

    if (this.activeDepositOccurence && this.activeDepositOccurence.occurence) {
      this.SelectedOccurenceFormControl.setValue(
        this.occurences.find(
          (o) => o.value == this.activeDepositOccurence.occurence,
        ),
      );
      this.occurences.forEach((o) => {
        if (
          this.selectedOccurences.find(
            (s) =>
              s.occurence_type == this.activeDepositOccurence.occurence_type &&
              o.value == this.activeDepositOccurence.occurence,
          )
        ) {
          o.selected = true;
        }
        //else o.selected=false;
      });
    } else {
      this.occurences.forEach((o) => {
        if (
          this.selectedOccurences.find(
            (s) =>
              s.occurence_type == o.occurenceType && o.value == s.occurence,
          )
        ) {
          o.selected = true;
        }
        //else o.selected=false;
      });
    }
  }

  SaveDeposit() {
    if (this.depositOccurenceForm.valid) {
      if (
        this.activeDepositOccurence &&
        Object.keys(this.activeDepositOccurence).length > 0
      ) {
        this.activeDepositOccurence.occurence_type =
          this.SelectedOccurenceTypeFormControl.value.value;
        if (
          this.SelectedOccurenceTypeFormControl.value.value ==
            OccurenceType.ApplyManually ||
          this.SelectedOccurenceTypeFormControl.value.value.toString() ==
            OccurenceType[OccurenceType.ApplyManually]
        ) {
          this.activeDepositOccurence.occurence = 0;
          this.activeDepositOccurence.occurence_name = '-';
        } else {
          this.activeDepositOccurence.occurence =
            this.SelectedOccurenceFormControl.value.value;
          this.activeDepositOccurence.occurence_name =
            this.SelectedOccurenceFormControl.value.key;
        }
        let deposit = this.activeDepositOccurence;
        this.ref.close({ deposit, index: this.activeEditIndex });
      } else {
        let deposit: PlanDeposit = {
          id: 0,
          plan_id: 0,
          deposit_name: '',
          occurence_type: this.SelectedOccurenceTypeFormControl.value.value,
          occurence:
            this.SelectedOccurenceTypeFormControl.value.value ==
              OccurenceType.ApplyManually ||
            this.SelectedOccurenceTypeFormControl.value.value.toString() ==
              OccurenceType[OccurenceType.ApplyManually]
              ? 0
              : this.SelectedOccurenceFormControl.value.value,
          occurence_name:
            this.SelectedOccurenceTypeFormControl.value.value ==
              OccurenceType.ApplyManually ||
            this.SelectedOccurenceTypeFormControl.value.value.toString() ==
              OccurenceType[OccurenceType.ApplyManually]
              ? '-'
              : this.SelectedOccurenceFormControl.value.key,
        };
        this.ref.close({ deposit });
      }
    } else {
      Object.keys(this.depositOccurenceForm.controls).forEach((field) => {
        const control = this.depositOccurenceForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  isValidDeposit() {
    if (
      this.SelectedOccurenceTypeFormControl.value.value ==
        OccurenceType.ApplyManually ||
      this.SelectedOccurenceTypeFormControl.value.value.toString() ==
        OccurenceType[OccurenceType.ApplyManually]
    ) {
      return this.AddOccurenceFormControl.value;
    } else {
      return true;
    }
  }

  closeDialog() {
    this.ref.close(null);
  }

  get SelectedOccurenceTypeFormControl(): UntypedFormControl {
    return this.depositOccurenceForm.get(
      'occurence_type',
    ) as UntypedFormControl;
  }

  set SelectedOccurenceTypeFormControl(value: any) {
    this.SelectedOccurenceTypeFormControl.setValue(value);
  }

  get SelectedOccurenceFormControl(): UntypedFormControl {
    return this.depositOccurenceForm.get('occurence') as UntypedFormControl;
  }

  get AddOccurenceFormControl(): UntypedFormControl {
    return this.depositOccurenceForm.get('add_occurence') as UntypedFormControl;
  }

  get GetOccurenceType() {
    return OccurenceType;
  }
}
